import {
  FETCH_EDI_REQUEST_RECORD_REQUEST,
  FETCH_EDI_REQUEST_RECORD_SUCCESS,
  FETCH_EDI_REQUEST_RECORD_FAILURE,
  CLEAR_EDI_REQUEST_RECORDS,
  FETCH_EDI_FORMAT,
  SET_EDI_FORMAT,
  SET_POPUP_RECORDS,
  SET_POPUP_FLAG,
} from "../actionTypes";

const intialState = {
  loading: null,
  popUpShow: false,
  ediReqRecords: [],
  error: "",
  popupRecords: { recordlist: [] },
};

const ediReqRecordsReducer = (state = intialState, action) => {
  switch (action.type) {
    case FETCH_EDI_REQUEST_RECORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_EDI_REQUEST_RECORD_SUCCESS:
      return {
        ...state,
        loading: false,
        ediReqRecords: action.payload,
        error: "",
      };
    case SET_POPUP_RECORDS:
      return {
        ...state,

        popupRecords: { recordlist: action.payload },
      };
    case SET_POPUP_FLAG:
      return {
        ...state,

        popUpShow: action.payload,
      };

    case FETCH_EDI_REQUEST_RECORD_FAILURE:
      return {
        ...state,
        loading: false,
        ediReqRecords: [],
        error: action.payload,
      };
    case CLEAR_EDI_REQUEST_RECORDS:
      return {
        ...state,
        loading: null,
        ediReqRecords: [],
        error: "",
        popUpShow: false,
      };
    case SET_EDI_FORMAT:
      return {
        ediFormat: {
          action: action.payload.action,
          doctype: action.payload.doctype,
          record: action.payload.response,
        },
      };
    default:
      return state;
  }
};
export default ediReqRecordsReducer;
